import type { TrigKey } from './keys';

export const tl: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Matematika · Trigonometriya',
  'panel.experiment': 'Eksperimento',
  'panel.params': 'Mga Parameter',
  'panel.scene': 'Pumili ng eksperimento',
  'experiment.right-triangle.label': 'Right na tatsulok',
  'experiment.unit-circle.label': 'Unit circle',
  'experiment.wave-studio.label': 'Wave studio',
  'experiment.identity-playground.label': 'Mga identidad',
  'experiment.triangle-solver.label': 'Triangle solver',
  'experiment.circular-polar.label': 'Pabilog & polar',
  'hint.line1': 'I-drag ang mga punto, gamitin ang slider.',
  'hint.line2': 'Ang aral ay nasa heometriya, hindi sa teksto.',
  'rt.angle.a': 'Anggulo A',
  'rt.angle.b': 'Anggulo B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radian',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Snap sa 30°/45°/60°',
  'uc.units': 'Mga unit',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Ipakita ASTC',
  'uc.snap.common': 'Snap sa karaniwang anggulo',
  'uc.angle.value': '∠',
  'uc.units.deg': 'degrees',
  'uc.units.rad': 'rad',
  'uc.units.both': 'deg+rad',
  'ws.fn': 'Function',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Amplitude',
  'ws.frequency': 'B — Frequency',
  'ws.phase': 'C — Phase shift',
  'ws.shift': 'D — Vertical shift',
  'ws.rform.toggle': 'Derivasyon ng R-form',
  'ws.rform.a': 'a (sin coeff)',
  'ws.rform.b': 'b (cos coeff)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'I-reset',
  'ws.base': 'Ipakita ang base curve',
  'ip.id.pythagorean': 'Pythagorean',
  'ip.id.reciprocal': 'Reciprocal',
  'ip.id.quotient': 'Quotient',
  'ip.id.sum': 'Sum',
  'ip.id.difference': 'Difference',
  'ip.id.double': 'Double-angle',
  'ip.id.half': 'Half-angle',
  'ip.play': 'Play',
  'ip.pause': 'Pause',
  'ip.step': 'Hakbang',
  'ip.reset': 'I-reset',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'Sa v2 — kailangan ng pagpapatunay na ito ng mas detalyadong konstruksyon.',
  'ts.area': 'Sukat',
  'ts.sineRule': 'Sine rule',
  'ts.cosineRule': 'Cosine rule',
  'ts.ambiguous.toggle': 'Ipakita ang ghost na tatsulok',
  'ts.reset': 'Bumalik sa equilateral',
  'ts.snap.integers': 'Snap sa integers',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Mga gilid',
  'ts.section.angles': 'Mga anggulo',
  'ts.section.sineRule': 'Sine rule',
  'ts.section.cosineRule': 'Cosine rule',
  'ts.section.area': 'Sukat',
  'cp.omega': 'Bilis na pa-anggulo',
  'cp.plot.y': 'I-plot ang y (sin)',
  'cp.plot.x': 'I-plot ang x (cos)',
  'cp.polar.label': 'Polar na pigura',
  'cp.polar.circle': 'Bilog (r = 1)',
  'cp.polar.rose': 'Rosas (r = sin 3θ)',
  'cp.polar.cardioid': 'Cardioid (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Maliit-na-anggulo (sin x ≈ x)',
  'cp.play': 'Play',
  'cp.pause': 'Pause',
  'cp.reset': 'I-reset',
  'cp.step': 'Hakbang π/12',
};
